export default __webpack_public_path__ + "static/media/cli-cenibra.b5cdc021.jpg";